import { useEffect } from 'react';

import { useMediaPlayer } from '../MediaPlayerProvider';

export function useSecondConsumed(cb: () => void) {
  const { player } = useMediaPlayer();
  useEffect(() => {
    if (player !== null) {
      player.on('secondconsumed', cb);
      return () => {
        player.off('secondconsumed', cb);
      };
    }
    return;
  }, [cb, player]);
}
